import React from "react";
import { useTranslation } from "../../../hooks/useTranslation";
import SectionHeadingStyle3 from "../../SectionHeading/SectionHeadingStyle3";
import Spacing from "../../Spacing";
import QuickActions from "../../QuickActions/QuickActions";

const DashboardAdmin = ({ darkMode }) => {
  const { translate } = useTranslation();

  return (
    <>
      <Spacing lg="145" md="80" />
      <div className="container">
        <SectionHeadingStyle3
          title={translate("dashboardAdmin.title")}
          subTitle={translate("dashboardAdmin.subtitle")}
          variant="cs_style_1 text-center"
        />
        <Spacing lg="90" md="45" />

        {/* Ações Rápidas */}
        <QuickActions variant="admin" />
      </div>
      <Spacing lg="145" md="80" />
    </>
  );
};





export default DashboardAdmin;
